import { Tooltip } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { CalculatorType } from 'typings'
import { IconContainer } from 'ui'
import {
  promotionTypeIcons,
  promotionTypeMessages,
} from '../utils/promotionTypes'

type Props = {
  type: CalculatorType
  className?: string
}

export function PromotionIcon({ type, className }: Props) {
  const Icon = promotionTypeIcons[type]
  const { $t } = useIntl()

  return (
    <Tooltip text={$t(promotionTypeMessages[type])}>
      <div className={className}>
        <IconContainer>
          <Icon data-testid={`promotion-type-icon-${type}`} />
        </IconContainer>
      </div>
    </Tooltip>
  )
}
